<template>
  <div style="height: 100%">
    <modelGuidance
      v-if="!notModelFirst"
      :disableModelGuidance="disableModelGuidance" />
    <modelGroupGuidance
      v-else-if="!notModelGroupFirst"
      :disableModelGroupGuidance="disableModelGroupGuidance" />
    <div
      v-else
      class="data-content-box">
      <dragPanel v-show="dataManageTreeVisible">
        <data-manage-tree
          ref="dataManageTree"
          class="guidesTree"
          :width="242"
          :data="treeData"
          :nodeClick="handleNodeClick"
          :hideDataManageTree="hideDataManageTree" />
      </dragPanel>
      <div
        v-if="!dataManageTreeVisible"
        class="icon-box">
        <icon-svg
          icon-class="ic-ico_an"
          class="icon"
          title="展开目录树"
          @click.native="openDataManageTree" />
      </div>
      <div class="data-content page-primary">
        <div
          v-if="loading"
          class="loading-box">
          <div
            v-loading="true"
            class="loading" />
        </div>
        <breadcrumb
          :breadcrumbList="breadcrumbList"
          :breadcrumbClick="breadcrumbClick" />
        <div class="operate-area">
          <div class="common-button-box">
            <div v-if="isButtonVisible('upload')">
              <el-button
                key="uploadBtn"
                type="primary"
                size="small"
                class="upload-btn gr9 primary-btn"
                id="bim-upload"
                @click="uploadFile">
                上传
              </el-button>
            </div>
            <div v-if="isButtonVisible('newModelGroup')">
              <el-button
                size="small"
                class="primary-btn gr9"
                type="primary"
                @click="addNode(2)">
                新建模型组
              </el-button>
            </div>
            <div v-if="isButtonVisible('newFolder')">
              <el-button
                size="small"
                class="normal-btn gr9"
                @click="addNode(1)"
                >新建文件夹</el-button
              >
            </div>
            <div
              v-if="isBatchButtonVisible('modelBatchOperate', '')"
              class="common-dropdown-box">
              <el-dropdown
                placement="bottom-start"
                @command="modelBatchOperate">
                <el-button
                  size="small"
                  class="normal-btn gr9">
                  批量操作 <i class="el-icon-arrow-down" />
                </el-button>
                <el-dropdown-menu
                  slot="dropdown"
                  class="dropdown-menu dropdown-primary"
                  :append-to-body="false">
                  <el-dropdown-item
                    v-if="
                      isBatchButtonVisible('setCoordinate', 'modelBatchOperate')
                    "
                    command="0">
                    设置坐标系
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      isBatchButtonVisible('submitConvert', 'modelBatchOperate')
                    "
                    command="1">
                    提交转换
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="isBatchButtonVisible('download', 'modelBatchOperate')"
                    command="2">
                    下载
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="isBatchButtonVisible('moveTo', 'modelBatchOperate')"
                    command="3">
                    移动到
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      isBatchButtonVisible('deleteNode', 'modelBatchOperate')
                    "
                    command="5">
                    删除
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="isBatchButtonVisible('share', 'modelBatchOperate')"
                    command="6">
                    分享
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div
              v-if="isBatchButtonVisible('modelGroupBatchOperate', '')"
              class="common-dropdown-box">
              <el-dropdown
                placement="bottom-start"
                @command="modelGroupBatchOperate">
                <el-button
                  size="small"
                  class="normal-btn gr9">
                  批量操作 <i class="el-icon-arrow-down" />
                </el-button>
                <el-dropdown-menu
                  slot="dropdown"
                  class="dropdown-menu dropdown-primary"
                  :append-to-body="false">
                  <el-dropdown-item
                    v-if="
                      isBatchButtonVisible(
                        'setCoordinate',
                        'modelGroupBatchOperate'
                      )
                    "
                    command="1">
                    设置坐标系
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      isBatchButtonVisible('moveTo', 'modelGroupBatchOperate')
                    "
                    command="3">
                    移动到
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      isBatchButtonVisible(
                        'deleteNode',
                        'modelGroupBatchOperate'
                      )
                    "
                    command="5">
                    删除
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      isBatchButtonVisible('share', 'modelGroupBatchOperate')
                    "
                    command="6">
                    分享
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="search-box">
            <el-input
              class="search-input input-primary search-box-title-input"
              size="small"
              v-model="keywords"
              placeholder="请输入文件名"
              clearable
              @clear="search"
              @keyup.enter.native="search">
              <i
                slot="suffix"
                class="el-input__icon el-icon-search icon"
                @click="search" />
            </el-input>
          </div>
        </div>
        <div
          v-if="!modelTableVisible && !modelGroupTableVisible"
          class="common-empty-box"
          key="emptyPage">
          <bj-empty
            :image="getNoDataImg()"
            class="empty-page">
            <template slot="description">
              <div
                :class="`${
                  isMicroAppMode() ? 'description-box empty-text' : 'empty-text'
                }`">
                抱歉，没有找到相关内容
              </div>
            </template>
            <div
              class="empty-tips"
              v-if="isButtonVisible('newFolder')">
              <div v-if="isModelManage()">
                <div v-if="!isLinux">
                  模型管理用于管理单个文件，当前支持的格式：pak、rvt、3dxml、gim、ifc、igms、fbx、3dm、stp、gltf、
                  skp、glb、dgn、nwd、nwc、rvm、obj、obj.zip、stl
                </div>
                <div
                  v-else
                  class="linux-tip-box">
                  模型管理用于管理单个文件，当前仅支持pak、ifc、rvt、obj、obj.zip、stl、cdy格式
                </div>
              </div>
              <div v-if="isModelGroupManage()">
                <div v-if="!isLinux">
                  每个模型组内可包含多个文件，当前支持的格式：pak、rvt、3dxml、gim、ifc、igms、fbx、3dm、stp、gltf、
                  skp、glb、dgn、nwd、nwc、rvm、obj、obj.zip、stl
                </div>
                <div
                  v-else
                  class="linux-tip-box">
                  每个模型组内可包含多个文件，当前仅支持pak、ifc、rvt、obj、obj.zip、stl、cdy格式
                </div>
              </div>
            </div>
            <div class="common-button-box text-center-c btn-group-primary">
              <el-button
                v-if="isButtonVisible('upload')"
                key="uploadBtn"
                type="primary"
                size="small"
                class="upload-btn primary-btn gr9 guidesBtn"
                id="empty-bim-upload"
                @click="uploadFile">
                上传
              </el-button>
              <el-button
                v-if="isButtonVisible('newModelGroup')"
                type="primary"
                size="small"
                class="primary-btn gr9"
                @click="addNode(2)">
                新建模型组
              </el-button>
              <el-button
                v-if="isButtonVisible('newFolder')"
                size="small"
                class="normal-btn guidesModelBtn"
                @click="addNode(1)">
                新建文件夹
              </el-button>
            </div>
          </bj-empty>
        </div>
        <div
          class="data-view-box"
          v-show="modelTableVisible || modelGroupTableVisible">
          <model-table
            ref="modelTable"
            v-show="modelTableVisible"
            schemeType="Bim"
            operaWidth="180"
            :rootNodeId="rootNodeId"
            :nodeId="selectNodeData.nodeId"
            :name="keywords"
            :customUploader="customUploader"
            :updateModelTableVisible="updateModelTableVisible"
            :refreshCatalogTree="refreshCatalogTree"
            :handleCellClick="handleCellClick"
            :reNameNode="reNameNode"
            :submitConvert="submitConvert"
            :openConfigDialog="openConfigDialog"
            :openMoveTreeDialog="openMoveTreeDialog"
            :openModelVersionDialog="openModelVersionDialog"
            :openCoordinateDialog="openCoordinateDialog"
            :openShareDialog="openShareDialog"
            :openUvMapDialog="openUvMapDialog" />
          <model-group-table
            ref="modelGroupTable"
            v-show="modelGroupTableVisible"
            :rootNodeId="rootNodeId"
            :nodeId="selectNodeData.nodeId"
            :name="keywords"
            :customUploader="customUploader"
            :updateModelGroupTableVisible="updateModelGroupTableVisible"
            :refreshCatalogTree="refreshCatalogTree"
            :handleCellClick="handleCellClick"
            :reNameNode="reNameNode"
            :submitConvert="submitConvert"
            :openConfigDialog="openConfigDialog"
            :openVersionDialog="openVersionDialog"
            :openMoveTreeDialog="openMoveTreeDialog"
            :openCoordinateDialog="openCoordinateDialog"
            :openShareDialog="openShareDialog"
            :openFileTableDialog="openFileTableDialog"
            :updateModelGroupInfo="updateModelGroupInfo" />
        </div>
      </div>
    </div>
    <add-node-dialog
      :visible="nodeDialogVisible"
      :title="nodeDialogTitle"
      schemeType="Bim"
      :nodeType="nodeType"
      :nodeTreeType="nodeTreeType"
      :editMode="editMode"
      :nodeInfo="nodeInfo"
      :submitNode="submitNode"
      :closeDialog="closeNodeDialog" />
    <version-info-dialog
      :visible="versionInfoVisible"
      :versionInfo="versionInfo"
      :closeDialog="closeVersionDialog" />
    <FileConfigDialog
      :visible="fileConfigDialogVisible"
      :fileConfigInfo="fileConfigInfo"
      :submitConfig="submitConfig"
      :cancelConfig="cancelConfig" />
    <moveTreeDialogVue
      :visible="moveTreeDialogVisible"
      :data="moveTreeData"
      :nodeClick="moveTreeNodeClick"
      :submitMove="submitMove"
      :closeDialog="closeMoveTreeDialog" />
    <model-version-info
      :visible="modelVeresionInfoVisible"
      :versionInfo="modelVeresionInfo"
      :closeDialog="closeModelVersionDialog" />
    <CoordinateDialog
      :visible="coordinateDialogVisible"
      :dataSetType="dataSetType"
      :initCrsInfo="initCrsInfo"
      :submitInfo="setNodeCoordinates"
      :closeDialog="closeCoordinateDialog" />
    <CrsCheckDialog
      :visible="crsCheckDislogVisible"
      :readOnlyInfo="{}"
      :dataSetsIsQuoted="dataSetsIsQuoted"
      :continueSetCrs="continueSetCrs"
      :closeDialog="closeCrsCheckDialog" />
    <shareDialog
      :visible="shareDialogVisible"
      resourceType="dataSet"
      :resourceList="dataSetsToShare"
      :closeDialog="closeShareDialog" />
    <file-table
      :visible="fileTableVisible"
      :title="modelGroupInfo.nodeName"
      :isLinkModel="modelGroupInfo.isLinkModel"
      :nodeId="modelGroupInfo.nodeId"
      :modelVersion="modelGroupInfo.successVersion"
      :status="modelGroupInfo.status"
      :customUploader="customUploader"
      :refreshDataSetTable="refreshTable"
      :closeDialog="closeFileTableDialog" />
    <VerifyMsgDialog :customUploader="customUploader" />
    <RvtUvMapDialog
      :visible="rvtUvMapDialogVisible"
      :dataInfo="rvtInfo"
      :refreshDataSetTable="refreshTable"
      :closeDialog="closeUvMapDialog" />
  </div>
</template>

<script>
import modelGuidance from '@/components/module/userGuidance/modelGuidance.vue'
import modelGroupGuidance from '@/components/module/userGuidance/modelGroupGuidance.vue'
import dragPanel from '@/components/DragPanel.vue'
import dataManageTree from '@/components/module/dataManage/DataManageTree.vue'
import breadcrumb from '@/components/module/dataManage/Breadcrumb.vue'
import addNodeDialog from '@/components/module/dataManage/AddNodeDialog.vue'
import modelTable from '@/components/module/dataManage/ModelTable.vue'
import modelGroupTable from '@/components/module/dataManage/ModelGroupTable.vue'
import fileTable from '@/components/module/dataManage/FileTable.vue'
import moveTreeDialogVue from '@/components/module/dataManage/MoveTreeDialog.vue'
import versionInfoDialog from '@/components/module/dataManage/VersionInfoDialog.vue'
import modelVersionInfo from '@/components/module/dataManage/ModelVersionInfo.vue'
import CoordinateDialog from '@/components/CoordinateDialog.vue'
import CrsCheckDialog from '@/components/CrsCheckDialog.vue'
import shareDialog from '@/components/ShareDialog.vue'
import VerifyMsgDialog from '@/components/module/dataManage/VerifyMsgDialog.vue'
import RvtUvMapDialog from './components/RvtUvMapDialog.vue'
import FileConfigDialog from './bim/components/FileConfigDialog.vue'

import { isMicroAppMode } from '@/microAdapt/utils'

import CustomUploader from '@/utils/customUploader'
import { getParentNode, findNodeById } from '@/utils/generalMethods'

import { Store } from '@/utils/store'
import { bimButtons } from '@/utils/dictionary'

import {
  getUserGuidance,
  disabledModelGuidanceService,
  disabledModelGroupGuidanceService,
  getBimTreeService,
  addBimLevelNodes,
  addBimLeafNodes,
  modifyBimNodeName,
  bimQuoteService,
  setBimCoordinatesService,
  moveBimNode,
  configConvertParam,
  batchConfigConvertParam,
  addConvertQueue
} from '@/service/interface'
import { getSubMenuTitleElement } from '@/utils/guides.js'

export default {
  data() {
    return {
      notModelFirst: true,
      notModelGroupFirst: true,

      dataManageTreeVisible: true,
      rootNodeId: '',
      treeData: [],
      selectNodeData: {},

      loading: true,
      modelTableVisible: false,
      modelGroupTableVisible: false,

      isLinux: window.isLinux,

      keywords: '',
      breadcrumbList: [],

      nodeDialogVisible: false,
      nodeDialogTitle: '',
      nodeType: 0,
      nodeInfo: null,
      editMode: '',

      moveTreeDialogVisible: false,
      moveTreeData: [],
      nodesToMove: [],
      moveNodeData: null,

      fileConfigDialogVisible: false,
      fileConfigInfo: {},

      versionInfoVisible: false,
      versionInfo: {},

      modelVeresionInfoVisible: false,
      modelVeresionInfo: {},

      dataSetType: 'Model',
      crsCheckDislogVisible: false,
      dataSetsIsQuoted: [],
      coordinateDialogVisible: false,
      initCrsInfo: {},
      dataSetIdsToSetCrs: [],

      shareDialogVisible: false,
      dataSetsToShare: [],

      fileTableVisible: false,
      modelGroupInfo: {},

      rvtUvMapDialogVisible: false,
      rvtInfo: {},

      nodeTreeType: 1
    }
  },
  components: {
    modelGuidance,
    modelGroupGuidance,
    dragPanel,
    dataManageTree,
    breadcrumb,
    addNodeDialog,
    modelTable,
    modelGroupTable,
    fileTable,
    FileConfigDialog,
    moveTreeDialogVue,
    versionInfoDialog,
    modelVersionInfo,
    CoordinateDialog,
    CrsCheckDialog,
    shareDialog,
    VerifyMsgDialog,
    RvtUvMapDialog
  },
  created() {
    let uploaders = Store.uploaders
    let find = uploaders.find(el => el.schemeType === 'Bim')
    if (find) {
      this.customUploader = find.uploader
      this.customUploader.setCurrNodeType(1)
      this.customUploader.setCurrDataSetId('')
      this.customUploader.setUploadPathName('')
    } else {
      let mimeTypes = ''
      if (window.isLinux) {
        mimeTypes = '.pak,.ifc,.rvt,.obj,.obj.zip,.stl,.cdy'
      } else {
        // prettier-ignore
        mimeTypes = ".pak,.rvt,.3dxml,.gim,.ifc,.igms,.fbx,.3dm,.stp,.gltf,.skp,.glb,.dgn,.nwd,.nwc,.rvm,.obj,.obj.zip,.stl";
      }
      let uploaderOption = {
        accept: {
          title: '模型文件',
          extensions: '*',
          mimeTypes
        }
      }
      this.customUploader = new CustomUploader('Bim', uploaderOption)
    }
    let projId = this.$route.params.projId
    this.customUploader.setCurrProjId(projId)
  },
  mounted() {
    this.initData().then(() => {
      this.userGuidanceCheck().then(disableBeginner => {
        // TODO:
        this.notModelFirst =
          this.$theme.get().value === 'dark' ? disableBeginner : true
        // this.notModelFirst = false;

        if (this.notModelFirst) {
          this.$nextTick(() => {
            let nodeId = sessionStorage.getItem('BimNodeId')
            if (nodeId) {
              let selectData = this.findNodeById(this.treeData, nodeId)
              let domRef = this.$refs.dataManageTree
              if (selectData && domRef) {
                let node = domRef.getNode(selectData.nodeId)
                this.handleNodeClick(selectData, node)
              }
              sessionStorage.removeItem('BimNodeId')
            } else {
              let selectData = this.treeData[0]
              let domRef = this.$refs.dataManageTree
              if (domRef) {
                let node = domRef.getNode(selectData.nodeId)
                this.handleNodeClick(selectData, node)
              }
            }
          })
        }
      })
    })

    this.customUploader.on('startUploadFile', this.onStartUploadFile)
    this.$eventManage.on('refresh-catalogTree', this.refreshCatalogTree)
    this.$eventManage.on('refreshTable', this.refreshTable)

    // this.$nextTick(() => {
    //   setTimeout(() => {

    //     getSubMenuTitleElement([document.querySelector('.guidesTree'),document.querySelector('.guidesBtn'),document.querySelector('.guidesModelBtn')])
    //   }, 1000);
    // })
  },
  beforeDestroy() {
    this.customUploader.off('startUploadFile', this.onStartUploadFile)
    this.$eventManage.off('refresh-catalogTree', this.refreshCatalogTree)
    this.$eventManage.off('refreshTable', this.refreshTable)
  },
  methods: {
    userGuidanceCheck() {
      return new Promise(resolve => {
        if (this.isChecked('User.UserGuidance')) {
          getUserGuidance().then(response => {
            if (response.isSuccess) {
              let data = response.data
              if (data) {
                resolve(data.disableBeginner)
              } else {
                resolve(false)
              }
            } else {
              resolve(false)
            }
          })
        } else {
          resolve(true)
        }
      })
    },
    disableModelGuidance() {
      disabledModelGuidanceService().then(response => {
        if (response.isSuccess) {
          this.notModelFirst = true
          this.$nextTick(() => {
            let nodeId = sessionStorage.getItem('BimNodeId')
            if (nodeId) {
              let selectData = this.findNodeById(this.treeData, nodeId)
              if (selectData) {
                let node = this.$refs.dataManageTree.getNode(selectData.nodeId)
                this.handleNodeClick(selectData, node)
              }
              sessionStorage.removeItem('BimNodeId')
            } else {
              let selectData = this.treeData[0]
              let node = this.$refs.dataManageTree.getNode(selectData.nodeId)
              this.handleNodeClick(selectData, node)
            }
          })
        }
      })
    },
    disableModelGroupGuidance() {
      disabledModelGroupGuidanceService().then(response => {
        if (response.isSuccess) {
          this.notModelGroupFirst = true
          this.$nextTick(() => {
            let selectData = this.treeData[1]
            let node = this.$refs.dataManageTree.getNode(selectData.nodeId)
            this.handleNodeClick(selectData, node)
          })
        }
      })
    },
    checkModelGroupNotFirst(nodeData) {
      return new Promise(resolve => {
        if (
          nodeData.nodeType === 3 &&
          nodeData.formatType === 2 &&
          this.isChecked('User.UserGuidance')
        ) {
          getUserGuidance().then(data => {
            if (data.isSuccess) {
              // if (!data.data) {
              // TODO:
              if (data.data) {
                // 为星云跳过新手引导
                if (isMicroAppMode()) {
                  this.notModelGroupFirst = true
                } else {
                  this.notModelGroupFirst =
                    this.$theme.get().value === 'dark'
                      ? data.data.disableGroupBeginner
                      : true
                }
              } else {
                // 为星云跳过新手引导
                if (isMicroAppMode()) {
                  this.notModelGroupFirst = true
                } else {
                  this.notModelGroupFirst =
                    this.$theme.get().value === 'dark' ? false : true
                }
              }
              // TODO:
              resolve(this.notModelGroupFirst)
              // resolve(true)
            }
          })
        } else {
          resolve(true)
        }
      })
    },
    openDataManageTree() {
      this.dataManageTreeVisible = true
    },
    hideDataManageTree() {
      this.dataManageTreeVisible = false
    },
    initData() {
      return new Promise(resolve => {
        let projId = this.$route.params.projId
        getBimTreeService({ projId }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            if (data && data.subNodes) {
              this.treeData = data.subNodes
              resolve()
            } else {
              this.$message.error('获取资源目录失败，请稍后再试')
              this.$router.push('../../../projectList')
            }
          } else {
            this.$message.error(response.errMsg)
            this.$router.push('../../../projectList')
          }
        })
      })
    },
    refreshCatalogTree() {
      return new Promise(resolve => {
        let projId = this.$route.params.projId
        getBimTreeService({ projId }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            this.treeData = data.subNodes
            this.$nextTick(() => {
              let nodeId = this.selectNodeData.nodeId
              let selectData = this.findNodeById([data], nodeId)
              let domRef = this.$refs.dataManageTree
              if (selectData && domRef) {
                this.selectNodeData = selectData
                domRef.setCurrentKey(selectData.nodeId)
              }
            })
            resolve()
          } else {
            this.$message.error(response.errMsg)
            this.$router.push('../../../projectList')
          }
        })
      })
    },
    refreshTable() {
      let formatType = this.selectNodeData.formatType
      if (formatType !== undefined) {
        if (formatType === 1) {
          if (this.$refs.modelTable) {
            this.$refs.modelTable.uploadDataList().then(total => {
              this.updateModelTableVisible(total)
            })
          }
        } else {
          let nodeType = this.selectNodeData.nodeType
          if (nodeType !== 2) {
            if (this.$refs.modelGroupTable) {
              this.$refs.modelGroupTable.uploadDataList().then(total => {
                this.updateModelGroupTableVisible(total)
              })
            }
          }
        }
      }
    },
    search() {
      let formatType = this.selectNodeData.formatType
      if (formatType === 1) {
        this.$refs.modelTable.uploadDataList()
      } else {
        let nodeType = this.selectNodeData.nodeType
        if (nodeType !== 2) {
          this.$refs.modelGroupTable.uploadDataList()
        }
      }
    },
    handleCellClick(row) {
      let node = this.$refs.dataManageTree.getNode(row.nodeId)
      this.handleNodeClick(row, node)
    },
    handleNodeClick(nodeData, node) {
      this.checkModelGroupNotFirst(nodeData).then(result => {
        if (result) {
          this.loading = true
          this.$refs.dataManageTree.setCurrentKey(nodeData.nodeId)
          this.selectNodeData = nodeData
          sessionStorage.setItem('BimNodeId', this.selectNodeData.nodeId)

          this.breadcrumbList = this.getBreadCrumbList(node)
          this.keywords = ''
          let formatType = nodeData.formatType
          this.nodeTreeType = nodeData.formatType
          if (formatType === 1) {
            this.$nextTick(() => {
              if (this.$refs.modelTable) {
                this.$refs.modelTable.uploadDataList(1).then(total => {
                  this.updateModelTableVisible(total)
                  this.loading = false
                })
              }
            })
          } else {
            this.$nextTick(() => {
              if (this.$refs.modelGroupTable) {
                this.$refs.modelGroupTable.uploadDataList(1).then(total => {
                  this.updateModelGroupTableVisible(total)
                  this.loading = false
                })
              }
            })
          }
        }
      })
    },
    breadcrumbClick(data) {
      if (this.breadcrumbList.length === 1) return
      let selectData = this.findNodeById(this.treeData, data.id)
      let node = this.$refs.dataManageTree.getNode(selectData.nodeId)
      this.handleNodeClick(selectData, node)
    },
    uploadFile() {
      this.customUploader.setStatus('waiting')
    },
    onStartUploadFile() {
      this.$eventManage.fire('startUploadFile')
    },
    addNode(nodeType) {
      let node = this.$refs.dataManageTree.getNode(this.selectNodeData.nodeId)
      if (node && node.level > window.maxLevel) {
        this.$message.warning(`最多只支持${window.maxLevel + 1}级`)
        return false
      }

      this.nodeDialogVisible = true
      this.nodeDialogTitle = nodeType === 1 ? '新建文件夹' : '新建模型组'
      this.nodeType = nodeType
      this.editMode = 'addNode'
    },
    reNameNode(nodeInfo) {
      let nodeType = nodeInfo.nodeType

      this.nodeDialogVisible = true
      this.nodeDialogTitle = nodeType === 1 ? '重命名文件夹' : '重命名模型组'
      this.nodeType = nodeType
      this.editMode = 'reNameNode'
      this.nodeInfo = nodeInfo
    },
    closeNodeDialog() {
      this.nodeDialogVisible = false
      this.nodeDialogTitle = ''
      this.nodeType = 0
      this.editMode = ''
      this.nodeInfo = null
    },
    submitNode(paramsInfo) {
      return new Promise(resolve => {
        if (this.editMode === 'addNode') {
          if (this.nodeType === 1) {
            let params = {
              parentId: this.selectNodeData.nodeId,
              nodeNames: [paramsInfo.nodeName]
            }
            addBimLevelNodes(params).then(result => {
              if (result.isSuccess) {
                let data = result.data[0]
                this.refreshCatalogTree().then(() => {
                  let selectData = this.findNodeById(this.treeData, data.nodeId)
                  if (selectData) {
                    let node = this.$refs.dataManageTree.getNode(
                      selectData.nodeId
                    )
                    this.handleNodeClick(selectData, node)
                  }
                })
                resolve(result)
              } else {
                resolve(result)
              }
            })
          } else {
            let params = {
              projId: this.$route.params.projId,
              parentId: this.selectNodeData.nodeId,
              isLinkModel: paramsInfo.isLinkModel,
              dataSetNames: [paramsInfo.nodeName]
            }
            addBimLeafNodes(params).then(result => {
              if (result.isSuccess) {
                this.refreshCatalogTree().then(() => {
                  this.refreshTable()
                })
                resolve(result)
              } else {
                resolve(result)
              }
            })
          }
        }

        let dataInfo = this.nodeInfo
        if (this.editMode === 'reNameNode') {
          let params = {
            nodeId: dataInfo.nodeId,
            nodeName: paramsInfo.nodeName
          }
          modifyBimNodeName(params).then(result => {
            if (result.isSuccess) {
              this.refreshCatalogTree()
              this.refreshTable()
              resolve(result)
            } else {
              resolve(result)
            }
          })
        }
      })
    },
    modelBatchOperate(command) {
      switch (command) {
        case '0':
          this.$refs.modelTable.batchSetCoordinate()
          break
        case '1':
          this.$refs.modelTable.batchSubmitConvertFiles()
          break
        case '2':
          this.$refs.modelTable.batchDownloadFiles()
          break
        case '3':
          this.$refs.modelTable.batchMoveNode()
          break
        case '5':
          this.$refs.modelTable.batchDeleteNode()
          break
        case '6':
          this.$refs.modelTable.batchShare()
          break
        default:
          break
      }
    },
    modelGroupBatchOperate(command) {
      switch (command) {
        case '1':
          this.$refs.modelGroupTable.batchSetCoordinate()
          break
        case '2':
          console.log('分享')
          break
        case '3':
          this.$refs.modelGroupTable.batchMoveNode()
          break
        case '5':
          this.$refs.modelGroupTable.batchDeleteNode()
          break
        case '6':
          this.$refs.modelGroupTable.batchShare()
          break
        default:
          break
      }
    },
    openVersionDialog(versionInfo) {
      this.versionInfo = versionInfo
      this.versionInfoVisible = true
    },
    closeVersionDialog() {
      this.versionInfo = {}
      this.versionInfoVisible = false
    },
    openModelVersionDialog(modelVersionInfo) {
      this.modelVeresionInfo = modelVersionInfo
      this.modelVeresionInfoVisible = true
    },
    closeModelVersionDialog() {
      this.modelVeresionInfo = {}
      this.modelVeresionInfoVisible = false
    },
    openCoordinateDialog(dataSetIdsToSetCrs, dataSetInfo) {
      this.dataSetIdsToSetCrs = dataSetIdsToSetCrs
      if (dataSetInfo) {
        if (dataSetInfo.formatType === 1) {
          this.dataSetType = 'Model'
        } else {
          this.dataSetType = 'ModelGroup'
        }
        let initCrsInfo = {
          isBatchConfig: false,
          coordinatesConfig: dataSetInfo.coordinatesConfig,
          coordinatesDefault: dataSetInfo.coordinatesDefault
        }
        this.initCrsInfo = initCrsInfo
      }

      if (dataSetIdsToSetCrs.length > 1) {
        let initCrsInfo = {
          isBatchConfig: true
        }
        this.initCrsInfo = initCrsInfo
      }

      let dataSetIds = dataSetIdsToSetCrs
      bimQuoteService({ dataSetIds }).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let dataSets = data.dataSets
          if (dataSets.length) {
            this.dataSetsIsQuoted = dataSets
            this.openCrsCheckDialog()
          } else {
            this.coordinateDialogVisible = true
          }
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    openCrsCheckDialog() {
      this.crsCheckDislogVisible = true
    },
    continueSetCrs() {
      this.coordinateDialogVisible = true
    },
    closeCrsCheckDialog() {
      this.dataSetsIsQuoted = []
      this.crsCheckDislogVisible = false
    },
    setNodeCoordinates(params) {
      params.dataSetIds = this.dataSetIdsToSetCrs
      return new Promise(resolve => {
        setBimCoordinatesService(params).then(response => {
          if (response.isSuccess) {
            this.$message.success('设置坐标系成功')
            this.refreshTable()
            resolve(response)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    closeCoordinateDialog() {
      this.dataSetIdsToSetCrs = []
      this.initCrsInfo = {}
      this.dataSetType = 'Model'
      this.coordinateDialogVisible = false
    },
    openShareDialog(dataSetsToShare) {
      this.dataSetsToShare = dataSetsToShare
      this.shareDialogVisible = true
    },
    closeShareDialog() {
      this.dataSetsToShare = []
      this.shareDialogVisible = false
    },
    openFileTableDialog(modelGroupInfo) {
      this.fileTableVisible = true
      this.modelGroupInfo = modelGroupInfo
    },
    updateModelGroupInfo(modelGroupInfo) {
      if (modelGroupInfo.nodeId === this.modelGroupInfo.nodeId) {
        this.modelGroupInfo = modelGroupInfo
      }
    },
    closeFileTableDialog() {
      this.modelGroupInfo = {}
      this.fileTableVisible = false
    },
    openUvMapDialog(rvtInfo) {
      this.rvtUvMapDialogVisible = true
      this.rvtInfo = rvtInfo
    },
    closeUvMapDialog() {
      this.rvtInfo = {}
      this.rvtUvMapDialogVisible = false
    },
    openConfigDialog(dataSetsToConvert, fileConfigInfo) {
      this.dataSetsToConvert = dataSetsToConvert
      this.fileConfigInfo = fileConfigInfo
      this.fileConfigDialogVisible = true
    },
    async submitConfig(params) {
      let fileConfigInfo = this.fileConfigInfo
      // 解决模型组只有一个需要配置的文件时，更改配置无法再次转换的问题
      if (!fileConfigInfo.isModelManage) {
        params.isCovered = true
        params.projId = this.$route.params.projId
        const response = await batchConfigConvertParam(params)
        if (response.isSuccess) {
          this.submitConvert(this.dataSetsToConvert)
          this.fileConfigInfo = {}
          this.fileConfigDialogVisible = false
        } else {
          this.$message.error(response.errMsg)
        }
        return
      }

      if (fileConfigInfo.isBatchConfig || fileConfigInfo.isLinkModel) {
        params['projId'] = this.$route.params.projId
        batchConfigConvertParam(params).then(response => {
          if (response.isSuccess) {
            this.submitConvert(this.dataSetsToConvert)
            this.fileConfigInfo = {}
            this.fileConfigDialogVisible = false
          } else {
            this.$message.error(response.errMsg)
          }
        })
      } else {
        configConvertParam(params).then(response => {
          if (response.isSuccess) {
            this.submitConvert(this.dataSetsToConvert)
            this.fileConfigInfo = {}
            this.fileConfigDialogVisible = false
          } else {
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    cancelConfig() {
      this.datasetsToConvert = []
      this.fileConfigInfo = {}
      this.fileConfigDialogVisible = false
    },
    submitConvert(dataSetsToConvert) {
      if (this.isEmptyModelGroup(dataSetsToConvert)) {
        this.$message.error('模型组内为空，请先上传文件')
        return
      }

      this.releaseEngine()
      let params = {
        paramFilter: {}
      }
      if (dataSetsToConvert.length === 1) {
        let fileInfo = dataSetsToConvert[0]
        params['dataSetId'] = fileInfo.nodeId
        if (fileInfo.formatType === 2) {
          params['useDefaultConfig'] = true
        } else {
          params['useDefaultConfig'] = false
        }
        addConvertQueue(params).then(response => {
          if (response.isSuccess) {
            this.refreshCatalogTree()
            this.refreshTable()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      } else {
        let promiseArray = []
        dataSetsToConvert.forEach(item => {
          params['dataSetId'] = item.nodeId
          params['useDefaultConfig'] = true
          let promise = addConvertQueue(params)
          promiseArray.push(promise)
        })
        this.loopRequest(promiseArray, 5)
          .then(exceptionFiles => {
            let dataSetNameList = []
            exceptionFiles.forEach(item => {
              let find = dataSetsToConvert[item.index]
              if (find) {
                dataSetNameList.push(find.dataSetName)
              }
            })
            if (dataSetNameList.length) {
              let msgTail = '模型已转换成功,请勿重复提交转换!'
              let message = this.getWarningMessage(dataSetNameList, msgTail)
              this.$message.error(message)
            }

            this.refreshCatalogTree()
            this.refreshTable()
          })
          .catch(() => {
            this.refreshCatalogTree()
            this.refreshTable()
          })
      }
    },
    isEmptyModelGroup(dataSetsToConvert) {
      let isEmpty = false

      let count = 0
      dataSetsToConvert.forEach(item => {
        count += item.length
      })
      if (!count) {
        isEmpty = true
      }

      return isEmpty
    },
    async loopRequest(promiseArray, num, exceptionFiles = []) {
      let count = 0
      while (promiseArray.length > 0) {
        const temp = promiseArray.splice(0, num)
        await new Promise(resolve => setTimeout(resolve, 500)) // 添加一个延迟等待时间
        try {
          const responses = await Promise.all(temp)
          responses.forEach((res, index) => {
            if (!res.isSuccess) {
              res.index = index + count
              exceptionFiles.push(res)
            }
          })
        } catch (error) {
          console.error(error)
        }
        count += num
      }
      return exceptionFiles
    },
    openMoveTreeDialog(datas) {
      let formatType = this.selectNodeData.formatType
      this.moveTreeData = this.treeData.filter(
        el => el.formatType === formatType
      )

      this.nodesToMove = datas
      this.moveTreeDialogVisible = true
    },
    moveTreeNodeClick(data, node) {
      this.moveNodeData = null

      if (data.nodeType === 2) {
        // prettier-ignore
        this.$message.error('模型组中不能包含其它模型组或文件夹，请选择其他目录！')
        return
      }

      if (data.nodeId === this.selectNodeData.nodeId) {
        this.$message.error('数据已在当前目录中，请选择其他目录！')
        return
      }

      let moveDataIds = this.nodesToMove.map(el => el.nodeId)
      if (moveDataIds.includes(data.nodeId)) {
        this.$message.error('不能移动到自身目录之下，请选择其他目录！')
        return
      }
      let nodesToMoveNodeType = this.nodesToMove.map(el => el.nodeType)[0]
      // prettier-ignore
      if (nodesToMoveNodeType === 1 && node.level > window.maxLevel) {
        this.$message.error(`文件夹最多支持${window.maxLevel + 1}级，请选择其他目录！`)
        return
      }
      let parentNodes = []
      this.getParentNode(node, parentNodes)
      let parentNodeIds = parentNodes.map(el => el.data.nodeId)
      parentNodeIds.forEach(item => {
        if (moveDataIds.includes(item)) {
          this.$message.error('不能移动到子目录之下，请选择其他目录！')
          return
        }
      })

      this.moveNodeData = data
    },
    submitMove() {
      if (!this.moveNodeData) {
        this.$message.error('请选择有效的目标目录！')
        return
      }

      let params = {
        targetNodeId: this.moveNodeData.nodeId,
        nodeIds: this.nodesToMove.map(el => el.nodeId)
      }
      moveBimNode(params).then(response => {
        if (response.isSuccess) {
          this.refreshCatalogTree()
          this.refreshTable()

          this.$message.success('移动成功!')
          this.moveNodeData = null
          this.nodesToMove = []
          this.moveTreeDialogVisible = false
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    closeMoveTreeDialog() {
      this.moveNodeData = null
      this.nodesToMove = []
      this.moveTreeDialogVisible = false
    },
    getBreadCrumbList(node) {
      let parentNodes = []
      this.getParentNode(node, parentNodes)
      parentNodes.reverse()
      let breadcrumbList = []
      parentNodes.forEach(item => {
        let nodeData = item.data
        breadcrumbList.push({ id: nodeData.nodeId, name: nodeData.nodeName })
      })
      return breadcrumbList
    },
    initUploadBtn() {
      let uploadDom = document.getElementById('bim-upload')
      if (uploadDom) {
        let child = uploadDom.children[0]
        if (!child.className.includes('webuploader-pick')) {
          this.customUploader.uploader.addButton({ id: '#bim-upload' })
        }
      }

      // 空态页上传按钮
      let emptyUploadDom = document.getElementById('empty-bim-upload')
      if (emptyUploadDom) {
        let child = emptyUploadDom.children[0]
        if (!child.className.includes('webuploader-pick')) {
          this.customUploader.uploader.addButton({ id: '#empty-bim-upload' })
        }
      }
    },
    updateModelTableVisible(total) {
      this.modelGroupTableVisible = false
      this.$refs.modelGroupTable &&
        this.$refs.modelGroupTable.clearProgressTimer()

      let visible = false
      let currentFormatType = this.selectNodeData.formatType
      if (currentFormatType && currentFormatType === 1 && total) {
        visible = true
      }
      this.modelTableVisible = visible

      this.$nextTick(() => {
        this.initUploadBtn()

        let projName = this.$route.params.projName
        let levelPathName = this.selectNodeData.levelPathName
        this.customUploader.setCurrDataSetId(this.selectNodeData.nodeId)
        this.customUploader.setCurrNodeType(this.selectNodeData.nodeType)
        this.customUploader.setUploadPathName(`${projName}/${levelPathName}`)
      })
    },
    updateModelGroupTableVisible(total) {
      this.modelTableVisible = false
      this.$refs.modelTable && this.$refs.modelTable.clearProgressTimer()

      let visible = false
      let currentFormatType = this.selectNodeData.formatType
      if (currentFormatType && currentFormatType === 2 && total) {
        visible = true
      }
      this.modelGroupTableVisible = visible
    },
    releaseEngine() {
      if (window.BlackHole3D) {
        window.BlackHole3D.Model.unloadAllDataSet()
        window.BlackHole3D.releaseEngine()
        if (isMicroAppMode()) {
          sessionStorage.setItem('engineLoaded', false)
        }

        if (!isMicroAppMode()) {
          this.removeCanvasFromBody()
          window.BlackHole3D = null
        }
      }
    },
    isBatchButtonVisible(buttonName, parentButtonName) {
      let visible = false
      if (Object.keys(this.selectNodeData).length) {
        if (parentButtonName) {
          let childrens = bimButtons.find(
            el => el.name === parentButtonName
          ).children
          let find = childrens.find(el => el.name === buttonName)
          visible = this.isChecked(find.permissionCode)
        } else {
          let currentFormatType = this.selectNodeData.formatType
          let currentNodeType = this.selectNodeData.nodeType
          let find = bimButtons.find(el => el.name === buttonName)
          let visibleNodeType = find.formatType[currentFormatType]
          if (visibleNodeType) {
            if (!visibleNodeType.includes(currentNodeType)) {
              visible = false
              return visible
            }
          }

          let childrens = bimButtons.find(el => el.name === buttonName).children
          visible = childrens.some(el => this.isChecked(el.permissionCode))
        }

        if (visible) {
          visible = this.selectNodeData.isAuthorized
        }
      }
      return visible
    },
    isButtonVisible(buttonName) {
      let visible = false
      if (Object.keys(this.selectNodeData).length) {
        let currentFormatType = this.selectNodeData.formatType
        let currentNodeType = this.selectNodeData.nodeType
        let find = bimButtons.find(el => el.name === buttonName)
        let visibleNodeType = find.formatType[currentFormatType]
        if (visibleNodeType) {
          if (!visibleNodeType.includes(currentNodeType)) {
            visible = false
            return visible
          }
        }
        visible = this.isChecked(find.permissionCode)

        if (visible) {
          visible = this.selectNodeData.isAuthorized
        }
      }
      return visible
    },
    removeCanvasFromBody() {
      const canvasDom = document.getElementById('engineCanvas')
      canvasDom.remove()
    },
    getWarningMessage(dataSetNameList, messageTail) {
      let message = ''
      let messageHead = ''
      // 超过两个文件只展示前两个
      if (dataSetNameList.length > 2) {
        messageHead = `${dataSetNameList[0]}、${dataSetNameList[1]}等${dataSetNameList.length}个`
      } else {
        messageHead = dataSetNameList.join('、')
      }
      message = `${messageHead}${messageTail}`
      return message
    },
    getNoDataImg() {
      if (isMicroAppMode()) {
        return require('@/assets/img/no-data-nebula.png')
      } else {
        return require('@/assets/img/no-data.png')
      }
    },
    isModelManage() {
      let formatType = this.selectNodeData.formatType
      if (formatType === 1) {
        return true
      } else {
        return false
      }
    },
    isModelGroupManage() {
      let formatType = this.selectNodeData.formatType
      if (formatType === 2) {
        return true
      } else {
        return false
      }
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    findNodeById,
    getParentNode,
    isMicroAppMode
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';

.select-disable {
  .el-table__header-wrapper .el-checkbox {
    //找到表头那一行，然后把里面的复选框隐藏掉
    pointer-events: none;
    cursor: not-allowed;
  }
}

.data-content-box {
  .data-content {
    margin-bottom: 0;
    border-radius: 16px;
    overflow: hidden;

    .data-view-box {
      height: calc(100% - 95px);

      :deep(.common-table-box) {
        height: calc(100% - 65px) !important;
      }
    }
  }
}
</style>
